export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';
export const GET_OTHER_SUBJECT = 'GET_OTHER_SUBJECT';
export const SAVE_SUBJECT_STATUS = 'SAVE_SUBJECT_STATUS';
